import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    /* Registro */
    bancosMovimientos: [],
    /* Opciones de filtro y paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,

    fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).add(30, 'days').format('YYYY-MM-DD'),
    bancoCuenta: null,
    bancoMovimientoTipo: null,
    empresaId: 0,

    movimientosSeleccionados: [],

    bancosMovimientosRpt: [],

    rptIngresosGastos: [], 
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.bancosMovimientos = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).add(30, 'days').format('YYYY-MM-DD');
        state.bancoCuenta = null;
        state.bancoMovimientoTipo = null;
        state.empresaId = 0;
    },

    'INICIALIZAR'(state) {
        state.bancosMovimientos = [];
        // state.movimientosSeleccionados = []; 
    },
    'INICIALIZAR_PARAMETROS'(state) {
        state.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).add(30, 'days').format('YYYY-MM-DD');
        state.bancoCuenta = null;
        state.bancoMovimientoTipo = null;
    },
    'SET_BANCOS_MOVIMIENTOS'(state, bancosMovimientos) {
        state.bancosMovimientos = bancosMovimientos.map(bancoMovimiento => ({
            ...bancoMovimiento,
            _rowVariant: bancoMovimiento.readonly? 'read-only' : '',
            selected: false
        }));

        /* Recuperamos los seleccionados */
        if (state.movimientosSeleccionados) {
            state.movimientosSeleccionados.forEach(seleccionado => {
                let bancoMovimiento = state.bancosMovimientos.find(bm => bm.id == seleccionado.id);

                if (bancoMovimiento) {
                    // console.log(bancoMovimiento);
                    bancoMovimiento.selected = true;
                }
            });
        }
    },
    'PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'SELECCIONAR_MOVIMIENTO'(state, bancoMovimientoId) {
        let bancoMovimiento = state.bancosMovimientos.find(bm => bm.id == bancoMovimientoId);

        if (bancoMovimiento) {
            bancoMovimiento.selected = true;
            state.movimientosSeleccionados.push({id: bancoMovimientoId});
        }
    },
    'ANULAR_SELECCION_MOVIMIENTO'(state, bancoMovimientoId) {
        let bancoMovimiento = state.bancosMovimientos.find(bm => bm.id == bancoMovimientoId);
        let bancoMovimientoKey = state.movimientosSeleccionados.findIndex(bm => bm.id == bancoMovimientoId);

        if (bancoMovimiento & bancoMovimientoKey != -1) {
            bancoMovimiento.selected = false;
            
            state.movimientosSeleccionados.splice(itemKey, 1);
        }
    },
    'ACTUALIZAR_SELECCION_MOVIMIENTO'(state, bancoMovimientoId) {
        let bancoMovimiento = state.bancosMovimientos.find(bm => bm.id == bancoMovimientoId);
        
        if (bancoMovimiento) {
            if (bancoMovimiento.selected) {
                let bancoMovimientoKey = state.movimientosSeleccionados.findIndex(bm => bm.id == bancoMovimientoId);
                if (bancoMovimientoKey == -1) {
                    state.movimientosSeleccionados.push({id: bancoMovimientoId});
                }
            } else {
                let bancoMovimientoKey = state.movimientosSeleccionados.findIndex(bm => bm.id == bancoMovimientoId);
                if (bancoMovimientoKey != -1) {
                    state.movimientosSeleccionados.splice(bancoMovimientoKey, 1);
                }
            }
        }
    },
    'CLEAR_MOVIMIENTOS_SELECCIONADOS'(state) {
        state.bancosMovimientos
            .filter(bm => bm.selected)
            .forEach(bm => bm.selected = false);
        
        state.movimientosSeleccionados = [];
    },

    'INICIALIZAR_BANCOS_MOVIMIENTOS_RPT'(state) {
        state.bancosMovimientosRpt = [];
    },
    'SET_BANCOS_MOVIMIENTOS_RPT'(state, bancosMovimientosRpt) {
        state.bancosMovimientosRpt = bancosMovimientosRpt;
    },
    'INICIALIZAR_RPT_INGRESOS_GASTOS'(state) {
        state.rptIngresosGastos = [];
    },
    'SET_RPT_INGRESOS_GASTOS'(state, rptIngresosGastos) {
        state.rptIngresosGastos = rptIngresosGastos;
    },
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    inicializar: ({commit}) => {
        commit('INICIALIZAR');
    },
    inicializarParametros: ({commit}) => {
        commit('INICIALIZAR_PARAMETROS');
    },
    getBancosMovimientos: ({commit}, params) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR')
            
            let bancoCuentaId = 0;
            if (state.bancoCuenta) {
                if (state.bancoCuenta.id != 0) {
                    bancoCuentaId = state.bancoCuenta.id;
                }
            }
            
            if (bancoCuentaId != 0) {
                let queryString = '?pageSize=' + state.registrosPorPagina
                    + '&pageNumber=' + state.paginaActual
                    + '&fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                    + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD')
                    + '&bancoCuentaId=' + bancoCuentaId;

                if (state.bancoMovimientoTipo) {
                    if (state.bancoMovimientoTipo.id != 0) {
                        queryString += '&bancoMovimientoTipoId=' +  state.bancoMovimientoTipo.id;
                    }
                }

                apiAxios.get('bancosmovimientos/libro' + queryString)
                    .then(res => {
                        if (res.headers.pagination){
                            const pagination= JSON.parse(res.headers.pagination)
                            let params = {
                                paginaActual: pagination.currentPage,
                                registrosPorPagina: pagination.itemsPerPage,
                                totalRegistros: pagination.totalItems,
                                totalPaginas: pagination.totalPages,
                            }    
                            commit('PAGINATION', params);
                        }
                        commit('SET_BANCOS_MOVIMIENTOS', res.data)

                        if (params) {
                            if (params.clearMovimientosSeleccionados) {
                                commit('CLEAR_MOVIMIENTOS_SELECCIONADOS');
                            }
                        }

                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },
    delete ( {}, bancoMovimientoId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('bancosmovimientos/' + bancoMovimientoId + '/delete')
            .then(() => resolve())
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    conciliar ({state, commit}, params ) {
        return new Promise((resolve, reject) => {
            let bancoMovimientoId = 0;

            let conciliacion = {
                fechaCreditoDebito: params.fechaCreditoDebito,
            }

            if (params.bancoMovimientoId) {
                if (params.bancoMovimientoId != 0) {
                    bancoMovimientoId = params.bancoMovimientoId;
                }
            }

            if (bancoMovimientoId != 0) {
                apiAxios.post('bancosmovimientos/' + bancoMovimientoId + '/conciliar', conciliacion)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                let bancosMovimientosId;
                if (state.movimientosSeleccionados) {
                    if (state.movimientosSeleccionados.length != 0) {
                        bancosMovimientosId = state.movimientosSeleccionados
                            .map(bancoMovimiento => ({
                                id: bancoMovimiento.id 
                            }));
                    }
                }
                
                let errorMovimientos = true;
                if (bancosMovimientosId.length != 0) {
                    if (bancosMovimientosId.length != 0) {
                        errorMovimientos = false;
                    }
                }
                
                if (!errorMovimientos) {
                    conciliacion.bancosMovimientosId = bancosMovimientosId;

                    apiAxios.post('bancosmovimientos/conciliar', conciliacion)
                    .then(() => {
                        commit('CLEAR_MOVIMIENTOS_SELECCIONADOS');
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
    
                } else {
                    reject('Se produjo un error al recuperar el listado de movimientos seleccionados.');
                }
            }
        })            
    },

    seleccionarMovimiento({commit}, bancoMovimientoId) {
        return new Promise((resolve, reject) => {
            commit('SELECCIONAR_MOVIMIENTO', bancoMovimientoId)
        })            
    },
    anularSeleccionMovimiento({commit}, bancoMovimientoId) {
        return new Promise((resolve, reject) => {
            commit('ANULAR_SELECCION_MOVIMIENTO', bancoMovimientoId)
        })            
    },
    actualizarSeleccionMovimiento({commit}, bancoMovimientoId) {
        return new Promise((resolve, reject) => {
            commit('ACTUALIZAR_SELECCION_MOVIMIENTO', bancoMovimientoId)
        })            
    },
    cancelarSeleccionMovimientos({commit}) {
        return new Promise((resolve, reject) => {
            commit('CLEAR_MOVIMIENTOS_SELECCIONADOS')
        })            
    },

    anularConciliacion ({}, bancoMovimientoId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('bancosmovimientos/' + bancoMovimientoId + '/anular-conciliacion')
            .then(() => resolve())
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    devolverChequePropio ( {}, chequePropioId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('bancosmovimientos/' + chequePropioId + '/devolver')
            .then(() => resolve())
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    anularDevolucionChequePropio ( {}, chequePropioId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('bancosmovimientos/' + chequePropioId + '/anular-devolucion')
            .then(() => resolve())
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getBancosMovimientosRpt: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_BANCOS_MOVIMIENTOS_RPT')
            
            let bancoCuentaId = 0;
            if (state.bancoCuenta) {
                if (state.bancoCuenta.id != 0) {
                    bancoCuentaId = state.bancoCuenta.id;
                }
            }

            let queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD')
                + '&bancoCuentaId=' + bancoCuentaId;

            if (state.bancoMovimientoTipo) {
                if (state.bancoMovimientoTipo.id != 0) {
                    queryString += '&bancoMovimientoTipoId=' +  state.bancoMovimientoTipo.id;
                }
            }

            apiAxios.get('bancosmovimientos/libro/export' + queryString)
                .then(res => {
                    commit('SET_BANCOS_MOVIMIENTOS_RPT', res.data)

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getRptIngresosGastos: ( { commit }, params) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT_INGRESOS_GASTOS')
            
            let queryString = '?fechaDesde='+ params.fechaDesde
                + '&fechaHasta='+ params.fechaHasta;

            // let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
            //     + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');

            apiAxios.get('bancosmovimientos/reportes/ingresos-gastos' + queryString)
                .then(res => {
                    commit('SET_RPT_INGRESOS_GASTOS', res.data)

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

const getters = {
    getField,

    bancosMovimientosRpt (state) {
        return state.bancosMovimientosRpt;
    },
    rptIngresosGastos (state) {
        return state.rptIngresosGastos;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}